import { render, staticRenderFns } from "./VgPassCardPicker.vue?vue&type=template&id=9fba97b4&scoped=true&"
import script from "./VgPassCardPicker.vue?vue&type=script&lang=js&"
export * from "./VgPassCardPicker.vue?vue&type=script&lang=js&"
import style0 from "./VgPassCardPicker.vue?vue&type=style&index=0&id=9fba97b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fba97b4",
  null
  
)

export default component.exports